<template>
  <CockpitDialog
    :title="listInfo.name"
    @close="() => $emit('close')"
    left="460px"
    width="1000px"
    height="650px"
    top="120px"
  >
    <div class="flex h-full pt-10px plan-detail-wrap">
      <SpecialPlan
        v-if="listInfo.typeName === '专项应急预案'"
        :planRowId="listInfo.id"
        :statusList="statusList"
      />
      <ComprehensivePlan
        v-if="listInfo.typeName === '综合应急预案'"
        :planRowId="listInfo.id"
        :statusList="statusList"
      />
      <OnsiteDisposalPlan
        v-if="listInfo.typeName === '现场处置方案'"
        :planRowId="listInfo.id"
        :statusList="statusList"
      />
    </div>
  </CockpitDialog>
</template>

<script>
// components
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import SpecialPlan from './SpecialPlan'
import ComprehensivePlan from './ComprehensivePlan'
import OnsiteDisposalPlan from './OnsiteDisposalPlan'

export default {
  name: 'plan-detail-wrap',
  components: { CockpitDialog, SpecialPlan, ComprehensivePlan, OnsiteDisposalPlan },
  data() {
    return {
      page: {
        pageSize: 1,
        pageNo: 15,
        total: 0,
      },
      searchData: {},
      orgName: '',
      treeLoading: false,
      treeData: [],
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      statusList: [
        {
          value: 1,
          label: this.$t('待提交'),
        },
        {
          value: 2,
          label: this.$t('审批中'),
        },
        {
          value: 3,
          label: this.$t('待发布'),
        },
        {
          value: 4,
          label: this.$t('已发布'),
        },
        {
          value: 5,
          label: this.$t('已实施'),
        },
        {
          value: 6,
          label: this.$t('已废弃'),
        },
        {
          value: 7,
          label: this.$t('被驳回'),
        },
      ],
      tableData: [],
      tableLoading: false,
    }
  },
  methods: {
    /**
     * @description: 搜索区域树
     * @param {*} value
     * @param {*} data
     * @return {*}
     */
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    getTableData() {},
    // 定位
    goPoint() {},
    selectHandler(data) {
      //   this.nodeForm.id = data.id
      //   this.nodeForm.fatherNode = data.name
      //   this.nodeForm.fatherId = data.id
      //   this.selectName = data.name
      //   this.smallTreeFilter = ''
      //   this.$refs.fatherNode.blur()
      //   this.getTagList()
    },
  },
  created() {},

  props: {
    listInfo: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.tree-wrap {
  border: 1px solid #45f2eb33;
  background-color: #184c5c4c;
}
.table-wrap {
  border-left: 1px solid #2f7075;
}
</style>
